import { TextoModel } from "../models/textoModel"
import { TextoImpressaoActionModel, TextoImpressaoActionsTypes } from "./textoImpressaoActions"
import { TextoImpressaoInicial } from "./textoImpressaoInicial"

export function textoImpressaoReducer(
    state: TextoModel,
    action: TextoImpressaoActionModel
): TextoModel {
    switch (action.type) {
        case TextoImpressaoActionsTypes.INICIAL: {
            return action.payload
        }

        case TextoImpressaoActionsTypes.ATUALIZAR: {
            return action.payload
        }

        case TextoImpressaoActionsTypes.TOGGLE_ATIVO: {
            const { campo } = action.payload
            const config = state[campo]

            return {
                ...state,
                [campo]: {
                    ...config,
                    ativo: !config.ativo,
                },
            }
        }

        case TextoImpressaoActionsTypes.TOGGLE_NEGRITO: {
            const { campo } = action.payload
            const config = state[campo]

            return {
                ...state,
                [campo]: {
                    ...config,
                    negrito: !config.negrito,
                },
            }
        }

        case TextoImpressaoActionsTypes.ATUALIZAR_CAMPO: {
            const { campo, propriedade, valor } = action.payload
            const config = state[campo]

            return {
                ...state,
                [campo]: {
                    ...config,
                    [propriedade]: valor,
                },
            }
        }

        case TextoImpressaoActionsTypes.ATUALIZAR_PARAMETROS_GERAIS: {
            const { propriedade, valor } = action.payload
            return {
                ...state,
                parametrosGerais: {
                    ...state.parametrosGerais,
                    [propriedade]: valor,
                },
            }
        }

        case TextoImpressaoActionsTypes.RESETAR: {
            return {
                ...TextoImpressaoInicial,
                id: state.id,
                nome: state.nome,
            }
        }

        default:
            return state
    }
}
